import {Component, Injector} from '@angular/core';
import {GenericElm} from '../../player/generic.elm';
import {Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError} from "rxjs/operators";
import {ItemComponent} from "../../player/item.component";
import {SceneComponent} from "../scene/scene.component";
import {CachingService} from "../../services/caching/caching.service";
import {IPlayerContainer} from "../../interfaces/IPlayerContainer";
import {Expiration} from "../../interfaces/Expiration";

@Component({
  selector: 'app-catalog-item',
  template: '<div #component></div>',
  styleUrls: []
})
export class CatalogItemComponent extends ItemComponent {

  constructor(protected  injector: Injector) {
    super(injector);
    this.folder = 'catalog';
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        if (this.genericElm==null) {
          this.genericElm = new GenericElm(this.component);
        }
        this.aspectRatio = this.data.XmlItem[0]?.$.maintainAspectRatio == "1";
        this.fieldName = this.data.CatalogItem[0].$.field;
        if (this.fieldName=="ItemResourceMain") {
          this.fieldType = 'resource';
          return of('a')
        } else {
          this.fieldType = 'text';
          const font = this.data.CatalogItem[0].Font[0].$;
          this.genericElm.fontStyle = this.getFontStyle(font);
          return this.playerService.caching.requestFont(font);
        }
      }),
      switchMap(r=> {
        return this.invalidateData((<SceneComponent>this.parentPlayer).childProviderData, false);
      }),
      catchError(err => this.logError(err)),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }



  invalidateResource(value): Observable<any> {
    let obs$ = null;
    obs$ =  (<CachingService>this.playerService.caching).getResource(value);
    return obs$.pipe(
      switchMap(path => {
        let volume = 1.0;
        if (this.parentPlayer?.parentPlayer!=null) {
          volume = (<IPlayerContainer>(this.parentPlayer.parentPlayer)).volume;
        }
        return this.genericElm.setMedia(<string>path, this.aspectRatio, this.actualWidth, this.actualHeight, false, volume);
      }),
      catchError( e => this.invalidateHtml(value, false)) // some url have CORS issue
    )
  }

}
